import { Box, Button, Typography } from "@mui/material";

import DropdownButton from "components/DropdownButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "routes/paths";

function Navbar() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user?.user?.data);

  const tradeItems = [
    {
      name: "Basic Trade",
      onClick: () => navigate(ROUTE_PATHS.trade.basic("1", "3")),
    },
    {
      name: "Advanced Trade",
      onClick: () => navigate(ROUTE_PATHS.trade.advanced("1", "3")),
    },
    {
      name: "Convert Trade",
      onClick: () => navigate("/convert"),
    },
  ];

  const walletItems = [
    {
      name: "Portfolio",
      onClick: () => navigate("/portfolio"),
    },
    {
      name: (
        <>
          <Typography component="span">
            <Typography component="p">Spot Wallet</Typography>

            <Typography
              component="p"
              color="text.secondary"
              variant="subtitle2"
            >
              واریز و برداشت
            </Typography>
          </Typography>
        </>
      ),
      onClick: () => navigate("/wallet/spot"),
    },
    {
      name: "Margin Wallet",
      onClick: () => navigate("/wallet/margin"),
    },
    {
      name: "Investment Fund",
      onClick: () => navigate(ROUTE_PATHS.wallet.investment),
      hide: !user?.isHaveViewInvestment
    },
  ];

  const historyItems = [
    {
      name: "Spot History",
      onClick: () =>
        navigate("/history/trade-history?tradeTab=1&walletTypeId=1"),
    },
    {
      name: "Margin History",
      onClick: () =>
        navigate("/history/trade-history?tradeTab=1&walletTypeId=2"),
    },
    {
      name: "Referral History",
      onClick: () => navigate("/referral-history"),
    },
    {
      name: "Request History",
      onClick: () => navigate("/history/request"),
      hide: !user?.isHaveViewInvestment
    },
    {
      name: "Investment History",
      onClick: () => navigate("/history/investment"),
      hide: !user?.isHaveViewInvestment
    },
  ];

  return (
    <Box>
      <Button variant="text" color="text" onClick={() => navigate(ROUTE_PATHS.market)}>
        Market
      </Button>

      <DropdownButton variant="text" color="text" items={tradeItems}>
        Trade
      </DropdownButton>

      <DropdownButton variant="text" color="text" items={walletItems}>
        Wallet
      </DropdownButton>

      <DropdownButton variant="text" color="text" items={historyItems}>
        History
      </DropdownButton>
    </Box>
  );
}

export default Navbar;
